import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { createUser, getUsers } from 'api/user';
import { usersKeys } from 'api/queryKeys';
import type { IUserForm } from 'types/forms/user';
import { useMainCompanyQuery } from './useMainCompanyQuery';

export const useUsersQuery = () => {
  const { data: mainCompany } = useMainCompanyQuery();
  const companyId = mainCompany?.id ?? '';

  return useQuery({
    queryKey: usersKeys.list(companyId),
    queryFn: () => getUsers().then((res) => res.data),
    enabled: !!companyId
  });
};

export const useCreateUserMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: IUserForm) => createUser(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['users'] });
    }
  });
};
